import React from 'react'

const AnalyticsIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                fillRule="evenodd"
                className="hovered-paths"
            >
                <g>
                    <path
                        fill="#60a9eb"
                        d="M214.17 440.43c-.43 0-.88-.06-1.32-.18a4.995 4.995 0 0 1-3.5-6.14c10.22-37.49.21-66.16.11-66.44a5.01 5.01 0 0 1 3.02-6.4c2.6-.92 5.46.42 6.4 3.02l.1.31c19.84-2.17 78.37-4.1 80.54-3.33 2.6.94 3.95 3.8 3.02 6.39-.15.43-10.03 29.24.11 66.45.73 2.67-.84 5.41-3.5 6.14-.44.12-.89.18-1.32.18-1.89 0-63.25.33-80.67-1-.85.64-1.9 1-2.99 1z"
                        opacity={1}
                        data-original="#4d494a"
                        className=""
                    />
                    <path
                        fill="#1975c9"
                        d="M491.03 370.98H20.97c-11.56 0-20.96-9.4-20.96-20.96V60.56C.01 49 9.41 39.6 20.97 39.6h470.06c11.56 0 20.96 9.4 20.96 20.96v289.46c0 11.56-9.4 20.96-20.96 20.96z"
                        opacity={1}
                        data-original="#231f20"
                        className="hovered-path"
                    />
                    <path
                        fill="#c5dcf1"
                        d="M491.03 360.98c6.04 0 10.96-4.92 10.96-10.96V60.56c0-6.04-4.92-10.96-10.96-10.96H20.97c-6.04 0-10.96 4.92-10.96 10.96v289.46c0 6.04 4.92 10.96 10.96 10.96z"
                        opacity={1}
                        data-original="#eeeeee"
                        className=""
                    />
                    <path
                        fill="#1975c9"
                        d="M491.03 370.98H20.97c-11.56 0-20.96-9.4-20.96-20.96v-40.6h511.98v40.6c0 11.56-9.4 20.96-20.96 20.96zM343.18 472.4H168.82c-11.57 0-20.98-9.41-20.98-20.99 0-11.57 9.41-20.98 20.98-20.98h174.36c11.57 0 20.98 9.41 20.98 20.98 0 11.58-9.41 20.99-20.98 20.99z"
                        opacity={1}
                        data-original="#231f20"
                        className="hovered-path"
                    />
                    <path
                        fill="#ffab03"
                        d="M108.85 279.53H82.17c-2.76 0-5-2.24-5-5V147.04c0-2.76 2.24-5 5-5h26.69c2.76 0 5 2.24 5 5v127.49a5.01 5.01 0 0 1-5.01 5z"
                        opacity={1}
                        data-original="#ffab03"
                        className=""
                    />
                    <path
                        fill="#8aba55"
                        d="M167.41 279.53h-26.68c-2.77 0-5-2.24-5-5V118.87c0-2.76 2.23-4.99 5-4.99h26.68c2.76 0 5 2.23 5 4.99v155.66c0 2.76-2.24 5-5 5z"
                        opacity={1}
                        data-original="#8aba55"
                        className=""
                    />
                    <path
                        fill="#ec7076"
                        d="M225.96 279.53h-26.68c-2.76 0-5-2.24-5-5V84.49c0-2.77 2.24-5 5-5h26.68c2.77 0 5 2.23 5 5v190.04c0 2.76-2.24 5-5 5z"
                        opacity={1}
                        data-original="#ec7076"
                        className=""
                    />
                    <path
                        fill="#4e6575"
                        d="M241.86 279.53H66.28c-2.76 0-5-2.24-5-5 0-2.77 2.24-5 5-5h175.58c2.76 0 4.99 2.23 4.99 5 0 2.76-2.23 5-4.99 5zM359.79 272.05c-45.58 0-82.65-37.07-82.65-82.65 0-45.52 36.99-82.57 82.5-82.64l.15-.01c2.76 0 5 2.24 5 5v72.65h72.65c2.76 0 5 2.24 5 5l-.01.15c-.07 45.5-37.12 82.5-82.64 82.5z"
                        opacity={1}
                        data-original="#4e6575"
                        className=""
                    />
                    <path
                        fill="#ffab03"
                        d="M457.25 174.61h-77.67c-2.77 0-5-2.23-5-5V91.96c0-2.76 2.23-5 5-5 45.41 0 82.39 36.83 82.64 82.19.02.15.03.31.03.46 0 2.77-2.24 5-5 5z"
                        opacity={1}
                        data-original="#ffab03"
                        className=""
                    />
                </g>
            </svg>

        </>
    )
}

export default AnalyticsIcon